import { useTranslation } from 'react-i18next'
import PeopleIcons from '@/icons/PeopleIcons'
import { Building2, UserX } from 'lucide-react'
import EmployeeList from './EmployeeList'
import DepartmentList from './DepartmentList'

export const tabs = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTranslation()

    return [
        {
            label: t('employee_list'),
            value: 'employees',
            startIcon: <PeopleIcons className="w-4 h-4" />,
            component: <EmployeeList forcedStatus={[1]} />,
        },
        {
            label: t('employee:resigned_employee_list'),
            value: 'resigned',
            startIcon: <UserX className="w-4 h-4" />,
            component: (
                <EmployeeList
                    forcedStatus={[0]}
                    urlPrefix="resigned"
                    defaultSortBy="employee_code"
                    defaultSortOrder="desc"
                />
            ),
        },
        {
            label: t('department_list'),
            value: 'departments',
            startIcon: <Building2 className="w-4 h-4" />,
            component: <DepartmentList />,
        },
    ]
}
